var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuffler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3B55E6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116,107h-12c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1h12c0.55,0,1,0.45,1,1C117,106.55,116.55,107,116,107z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116,99h-12c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1h12c0.55,0,1,0.45,1,1C117,98.55,116.55,99,116,99z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116,91h-12c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1h12c0.55,0,1,0.45,1,1C117,90.55,116.55,91,116,91z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116,83h-12c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1h12c0.55,0,1,0.45,1,1C117,82.55,116.55,83,116,83z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116,115h-12c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1h12c0.55,0,1,0.45,1,1C117,114.55,116.55,115,116,115z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.79,83H4c-0.43,0-0.82-0.28-0.95-0.69c-0.13-0.41,0.01-0.86,0.36-1.12l60.21-44 C63.79,37.07,64,37,64.21,37H116c0.43,0,0.82,0.28,0.95,0.69c0.13,0.41-0.01,0.86-0.36,1.12l-60.21,44 C56.21,82.93,56,83,55.79,83z M7.06,81h48.4l57.47-42h-48.4L7.06,81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104,115H4c-0.55,0-1-0.45-1-1V82c0-0.55,0.45-1,1-1h100c0.55,0,1,0.45,1,1v32 C105,114.55,104.55,115,104,115z M5,113h98V83H5V113z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116,39H16c-0.55,0-1-0.45-1-1V6c0-0.55,0.45-1,1-1h100c0.55,0,1,0.45,1,1v32C117,38.55,116.55,39,116,39z  M17,37h98V7H17V37z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,15H4c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1h12c0.55,0,1,0.45,1,1C17,14.55,16.55,15,16,15z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,23H4c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1h12c0.55,0,1,0.45,1,1C17,22.55,16.55,23,16,23z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,31H4c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1h12c0.55,0,1,0.45,1,1C17,30.55,16.55,31,16,31z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,39H4c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1h12c0.55,0,1,0.45,1,1C17,38.55,16.55,39,16,39z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,7H4C3.45,7,3,6.55,3,6c0-0.55,0.45-1,1-1h12c0.55,0,1,0.45,1,1C17,6.55,16.55,7,16,7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,39c-0.55,0-1-0.45-1-1V6c0-0.55,0.45-1,1-1s1,0.45,1,1v32C27,38.55,26.55,39,26,39z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92,115c-0.55,0-1-0.45-1-1V82c0-0.55,0.45-1,1-1s1,0.45,1,1v32C93,114.55,92.55,115,92,115z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuffler);
export default __webpack_public_path__ + "static/media/muffler.b529407bf2b59e578b4b9773b9275ee2.svg";
export { ForwardRef as ReactComponent };